export const AVAILABLE_WIDGETS_KEY = Symbol()

export const CUSTOM_VIEW_NAME = 'Custom'
